import { FC } from 'react';
import { Text } from '@doda/io-react/common';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { useSelector } from 'react-redux';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { createPreBtn } from '@doda/common/src/logics/JobContent/createPreBtn';
import { convertQueryToURI } from '@doda/common/src/logics/JobContent/convertQueryToURI';
import { OtherPageLinkItem } from '@doda/pc/src/components/JobContent/OtherPageLinkItem';
import {
  OTHER_PAGE_LINK_TITLE,
  JOB_SEARCH_LINK_TEXT,
  JOB_RANKING_LINK_TEXT,
} from '@doda/common/src/constants/seo/jobContentCommonConstants';
import styles from './index.module.scss';

/**
 * OtherPageLinkのProps
 * @param targetName ページの一軸名
 */
interface Props {
  targetName: string;
}

export const OtherPageLink: FC<Props> = ({ targetName }) => {
  // queryの取得
  const queryParams = useSelector(appQueryParamsSelector);

  const jobSearchListUrl = makeStaticUrl(
    createPreBtn(convertQueryToURI(queryParams)),
    DODA_SITE_URL.jobSearchList
  );

  // 市区町村パラメータの場合、求人ランキングリンク生成しない
  const jobRankingUrl = queryParams.ci
    ? ''
    : makeStaticUrl(convertQueryToURI(queryParams), DODA_SITE_URL.jobRanking);

  return (
    <div className={styles.otherPageLink}>
      <Text
        as="h2"
        size="20"
        color="black_pc"
        weight="bold"
        className={styles.otherPageLink__title}
      >
        {targetName}
        {OTHER_PAGE_LINK_TITLE}
      </Text>
      <div className={styles.otherPageLink__list}>
        <OtherPageLinkItem
          title={JOB_SEARCH_LINK_TEXT.TITLE}
          description={JOB_SEARCH_LINK_TEXT.DESCRIPTION}
          linkUrl={jobSearchListUrl}
          imagePath={JOB_SEARCH_LINK_TEXT.IMAGE_PATH}
        />
        <OtherPageLinkItem
          title={JOB_RANKING_LINK_TEXT.TITLE}
          description={JOB_RANKING_LINK_TEXT.DESCRIPTION}
          linkUrl={jobRankingUrl}
          imagePath={JOB_RANKING_LINK_TEXT.IMAGE_PATH}
        />
      </div>
    </div>
  );
};
